import { render, staticRenderFns } from "./effectiveness.vue?vue&type=template&id=5201edde&scoped=true&"
import script from "./effectiveness.vue?vue&type=script&lang=js&"
export * from "./effectiveness.vue?vue&type=script&lang=js&"
import style0 from "./effectiveness.vue?vue&type=style&index=0&id=5201edde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5201edde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5201edde')) {
      api.createRecord('5201edde', component.options)
    } else {
      api.reload('5201edde', component.options)
    }
    module.hot.accept("./effectiveness.vue?vue&type=template&id=5201edde&scoped=true&", function () {
      api.rerender('5201edde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/effectiveness.vue"
export default component.exports